import axios from 'axios';
// import _ from 'lodash';
// Project imports
// import * as types from './actionTypes';
import * as urls from './urlTypes';

import {
  toastError,
} from '../util/toastUtils';


export const saveTeam = async team => {
  let url = `${urls.API_GATEWAY_URL}/api/admin-service/team`;
  let method = 'post';
  if (team.id) {
    url = `${urls.API_GATEWAY_URL}/api/admin-service/team/${team.id}`;
    method = 'put';
  }
  try {
    const response = await axios({
      url,
      method,
      withCredentials: true,
      data: team,
    });
    return response;
  } catch (error) {
    if (error.response) {
      return {
        error: error.response.data.message,
      };
    }
    toastError('Api failed to save team');
    return false;
  }
};

export const getTeamDetails = async teamId => {
  const url = `${urls.API_GATEWAY_URL}/api/admin-service/team/${teamId}`;
  try {
    const response = await axios({
      url,
      method: 'get',
      withCredentials: true,
      responseType: 'json',
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      return {
        error: error.response.data.message,
      };
    }
    toastError('Api failed to get team details');
    return false;
  }
};


export const deleteTeam = async teamId => {
  const url = `${urls.API_GATEWAY_URL}/api/admin-service/team/${teamId}`;
  const method = 'delete';
  try {
    const response = await axios({
      url,
      method,
      withCredentials: true,
    });
    return response;
  } catch (error) {
    // console.warn(`Account Details call failed: ${error}`);
    if (error.response) {
      return {
        error: error.response.data.message,
      };
    }
    toastError('Api failed to delete Team.');
    return false;
  }
};


export const activeTeam = async teamId => {
  const url = `${urls.API_GATEWAY_URL}/api/admin-service/team/${teamId}/activate`;
  const method = 'put';
  try {
    const response = await axios({
      url,
      method,
      withCredentials: true,
    });
    return response;
  } catch (error) {
    if (error.response) {
      return {
        error: error.response.data.message,
      };
    }
    toastError('Api failed to active team.');
    return false;
  }
};
